module.exports = __webpack_public_path__ + "img/tamaris.619b50b5.jpg";